export default __webpack_public_path__ + "static/media/the_nec.co.uk.f0b1940d.svg";